export function tryMultiple(condition: () => boolean, action: () => void, attemptCount: number = 0) {
  if (condition()) {
    action();
  } else if (attemptCount <= 5) {
    setTimeout(() => {
      tryMultiple(condition, action, attemptCount + 1);
    }, 250);
  }
}
